import { Breadcrumbs } from '../components/Breadcrumbs'
import { ContentCard } from '../components/ContentCard'
import { getContentsByType } from '../data/content'
import { useSeo } from '../hooks/useSeo'

export function StutisPage() {
  useSeo({
    title: 'ஸ்துதிகள் & மந்திரங்கள்',
    description: 'பாரம்பரிய ஸ்துதிகள், மந்திரங்கள் மற்றும் பொற்றிகள் — தமிழ் வரிகள் மற்றும் பொருள்.',
    path: '/stutis',
  })
  const items = getContentsByType(['traditional-stuti', 'mantra', 'potri'])

  return (
    <div className="page-hero">
      <div className="container section">
        <Breadcrumbs items={[{ label: 'முகப்பு', to: '/' }, { label: 'ஸ்துதிகள்' }]} />
        <div className="section-header">
          <h1>ஸ்துதிகள் & மந்திரங்கள்</h1>
          <p>பாரம்பரிய ஸ்தோத்திரங்கள், உச்சரிப்பு மற்றும் எளிய தமிழ்ப் பொருள்.</p>
        </div>
        <div className="card-grid card-grid--3">
          {items.map((item) => (
            <ContentCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </div>
  )
}
